import { useEffect } from "react";
import { LandingNav, LandingHero } from "./LandingHero";
import { LandingFeatures } from "./LandingFeatures";
import { LandingPortals, LandingSecurity, LandingFooter } from "./LandingSections";
import { LandingContact } from "./LandingContact";

export default function Landing() {
  useEffect(() => {
    const prev = document.title;
    document.title = "PatroGestPro — Gestionale per studi di infortunistica stradale";
    const html = document.documentElement;
    const wasSmooth = html.style.scrollBehavior;
    html.style.scrollBehavior = "smooth";
    return () => { document.title = prev; html.style.scrollBehavior = wasSmooth; };
  }, []);
  return (
    <div className="min-h-screen bg-[#0a0d14] text-slate-100 selection:bg-amber-500 selection:text-[#0a0d14]" data-testid="landing-page">
      <LandingNav />
      <main>
        <LandingHero />
        <LandingFeatures />
        <LandingPortals />
        <LandingSecurity />
        <LandingContact />
        <LandingFooter />
      </main>
    </div>
  );
}
